export default function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/react-textarea-autosize/node_modules/@babel/runtime/helpers/esm/inheritsLoose.js
// module id = 3cF5
// module chunks = 22 24 25